import { useEffect, useState } from 'react';

export const DEBOUNCE_MS = 350;

/**
 * Devuelve el valor estabilizado tras `delayMs` sin cambios.
 * Útil para búsquedas remotas: el fetch se dispara solo cuando el usuario
 * deja de tipear.
 */
export function useDebouncedValue<T>(value: T, delayMs = DEBOUNCE_MS): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
